import React from 'react';
import { FiMenu, FiWatch, FiMessageSquare } from 'react-icons/fi';

// Persistent mobile top bar — always visible regardless of the drawer's open/closed
// state. Clock and Messaging must never disappear on mobile, per the hard requirement.
export default function MobileTopBar({ onToggleDrawer, logoUrl, clock, totalUnread, onOpenChat }) {
  return (
    <div
      className="app-chrome d-flex d-lg-none align-items-center"
      style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        height: 'var(--topbar-height-mobile)',
        background: '#1b2638',
        zIndex: 1001,
        padding: '0 10px',
        gap: 10,
      }}
    >
      <button className="btn btn-outline-light btn-sm" onClick={onToggleDrawer} aria-label="Toggle navigation">
        <FiMenu size={18} />
      </button>
      {logoUrl
        ? <img src={logoUrl} alt="Company Logo" style={{ height: 24 }} />
        : <span className="text-white" style={{ fontSize: 15, fontWeight: 700 }}>quickLOG</span>}

      <div className="ms-auto d-flex align-items-center gap-2">
        {clock.visible && (
          <a href={clock.href} target="_blank" rel="noreferrer" title="Open Clock Terminal" className="btn btn-sm btn-outline-light">
            <FiWatch size={16} />
          </a>
        )}
        {onOpenChat && (
          <button className="btn btn-sm btn-outline-light position-relative" onClick={onOpenChat} title="Team Messages">
            <FiMessageSquare size={16} />
            {totalUnread > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: 10 }}>
                {totalUnread > 99 ? '99+' : totalUnread}
              </span>
            )}
          </button>
        )}
      </div>
    </div>
  );
}
